module.exports = __webpack_public_path__ + "static/media/sport-133.8631674b.jpg";